import template from './dateSelections.component.html';

/* @ngInject */
function DateSelectionController(DateTimeRangePickerService) {
  const vm = this;

  vm.setToday = () => {
    const dateTime = DateTimeRangePickerService.setToday();
    vm.activeSelection = dateTime.activeSelection;
    vm.selectionAction({ dateTime });
  };

  vm.setYesterday = () => {
    const dateTime = DateTimeRangePickerService.setYesterday();
    vm.activeSelection = dateTime.activeSelection;
    vm.selectionAction({ dateTime });
  };

  vm.setLastSevenDays = () => {
    const dateTime = DateTimeRangePickerService.setLastSevenDays();
    vm.activeSelection = dateTime.activeSelection;
    vm.selectionAction({ dateTime });
  };

  vm.setLastThirtyDays = () => {
    const dateTime = DateTimeRangePickerService.setLastThirtyDays();
    vm.activeSelection = dateTime.activeSelection;
    vm.selectionAction({ dateTime });
  };

  vm.setPreviousMonth = () => {
    const dateTime = DateTimeRangePickerService.setPreviousMonth();
    vm.activeSelection = dateTime.activeSelection;
    vm.selectionAction({ dateTime });
  };

  vm.isValidDateRange = () => DateTimeRangePickerService.isValidDateRange({ start: vm.start, end: vm.end });
}

export default {
  name: 'dateSelection',
  template,
  controller: DateSelectionController,
  bindings: {
    start: '<',
    end: '<',
    activeSelection: '<',
    selectionAction: '&',
    modalMode: '<?',
    doneAction: '&',
    cancel: '&'
  }
};
